export enum ReferenceOption {
  FriendsAndFamily = 1,
  SearchEngines = 2,
  OnlineAdsOnOtherWebsites = 3,
  SocialMedia = 4,
  Print = 5,
  DirectMailer = 6,
  OutdoorAds = 7,
  Radio = 8,
  TVAds = 9,
  CinemaAds = 10,
  EcommercePlatforms = 11,
  OnlineForumns = 12,
  Others = 13,
}
